//M.D 타입의 날짜 변환

function formatDateMDKorean(dateString) {
  const year = dateString.substring(0, 4);
  const month = dateString.substring(4, 6);
  const day = dateString.substring(6, 8);
  return `${parseInt(month)}월${parseInt(day)}일`;
}

export { formatDateMDKorean };
